namespace Solovis.Reports.Parameters.PropValueIncludes {


    export class PropValuesToIncludeSetEditorDialog {

        private _portalServices: Solovis.Portal.IPortalServices;

        private _resourceOptions: PropValueToIncludeResourceOption[];
        private _dateOptions: PropValueToIncludeDateOption[];

        private _setOptions: PropValuesToIncludeSetOptions;
        private _saveCallback;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        private _propDefs: InvData.Models.IdAndCodeObjectIndex<InvData.PropertyDefinition>;

        private _codeToResourceOptionMap = {};


        public constructor(options) {
            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._setOptions = options.setOptions ? options.setOptions : {};
            this._resourceOptions = options.resourceOptions;
            this._dateOptions = options.dateOptions;
            this._saveCallback = options.saveCallback;

            for (let resourceOption of this._resourceOptions) {
                this._codeToResourceOptionMap[resourceOption.code] = resourceOption;
            }
        }

        public async show() {
            this._propDefs = await this._portalServices.modelEnvironmentCachedData().getPropertyDefinitionsAsync();

          if (!Boolean((Solovis as any).Info.userEligibleForPropertyValuesToIncludeRedesign)) {
            this._internalShow();
          } else {
            
            // Add place to render the modal
            const modalContainer = document.createElement("div");
            modalContainer.classList.add("paux");
            document.body.appendChild(modalContainer);
            Solovis.UX.Utils.placeComponent("PropertyValuesToIncludeEditor", modalContainer, {
              // Save values
              onSubmit: (newOptions) => {
                this._saveCallback({ includeList: newOptions });
              },
              onClose: () => {
                // Clean up modal container
                modalContainer.remove();
              },
              selected: this._setOptions.includeList || [],
              dateOptions: this._dateOptions,
              resourceOptions: this._resourceOptions
            });
          }
            
        }

        public static getPropValueToIncludeLabel(
            propValueToInclude: PropValueToInclude,
            propDefs: InvData.Models.IdAndCodeObjectIndex<InvData.PropertyDefinition>,
            codeToResourceOptionMap
        ): string {

            let propDefName = "(Property)";
            let resourceRefName = "(Resource)";
            let dateRefName = null;

            if (propValueToInclude) {
                if (propValueToInclude.propDefId) {
                    let propDef = propDefs.tryGetById(propValueToInclude.propDefId);
                    if (propDef) {
                        propDefName = propDef.label;
                    }
                }

                if (propValueToInclude.resourceRef) {
                    if (propValueToInclude.resourceRef === "indirect") {
                        let indirectLabel = this.getPropValueToIncludeLabel(propValueToInclude.indirectRef, propDefs, codeToResourceOptionMap);
                        resourceRefName = "(" + indirectLabel + ")";
                    }
                    else {
                        let resourceOption = codeToResourceOptionMap[propValueToInclude.resourceRef];
                        if (resourceOption) {
                            resourceRefName = resourceOption.label;
                        }
                    }
                }
            }

            let descriptionText = propDefName + " For " + resourceRefName;
            if (dateRefName) {
                descriptionText += " At " + dateRefName;
            }

            if (propValueToInclude && propValueToInclude.exactDayOnly) {
                descriptionText += " (Exact Day Only)";
            }

            return descriptionText;
        }

        private _internalShow() {
            let setOptions = this._setOptions ? this._setOptions : {};

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                width: 800,
                labelColumnWidth: 100,
                portalServices: this._portalServices
            });
            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "includeList",
                label: "Include",

                initialValue: setOptions.includeList,

                applyStandardTextAlignTopPadding: true,

                createEditor: (createEditorOptions) => {
                    let groupListBuilder = new Solovis.UI.VerticalOrderedListBuilder({
                        controlHost: createEditorOptions.container,

                        itemTypeLabel: "Property",
                        showEditLinks: true,

                        values: createEditorOptions.initialValue,

                        editorCreator: (editorDiv, initialValue) => {
                            let lineItemState = {
                                propValueToInclude: initialValue
                            };

                            let updateEditorDiv = () => {
                                let descriptionText = PropValuesToIncludeSetEditorDialog.getPropValueToIncludeLabel(lineItemState.propValueToInclude, this._propDefs, this._codeToResourceOptionMap);

                                editorDiv.text(descriptionText);
                            };

                            updateEditorDiv();

                            let editorInfo = {
                                getValue: () => {
                                    return lineItemState.propValueToInclude;
                                },

                                showEditor: () => {
                                    PropValueToIncludeControl.showEditDialog(
                                        {
                                            resourceOptions: this._resourceOptions,
                                            dateOptions: this._dateOptions,
                                            propValueToInclude: lineItemState.propValueToInclude,
                                            propDefs: this._propDefs,
                                            codeToResourceOptionMap: this._codeToResourceOptionMap,
                                            portalServices: this._portalServices
                                        },
                                        (newPropValueToInclude) => {
                                            lineItemState.propValueToInclude = newPropValueToInclude;
                                            updateEditorDiv();
                                        });
                                }
                            };

                            return editorInfo;
                        },

                        newValueGenerator: () => {
                            let newPropValueToInclude = {};

                            return newPropValueToInclude;
                        }
                    });
                    groupListBuilder.setAsCurrentControl();

                    let editor = {
                        getValue: () => {
                            return groupListBuilder.getValues();
                        }
                    };

                    return editor;
                }
            });

            formBuilder.addEntry({
                name: "showFromDate",
                label: "Show Since Date",
                initialValue: !!setOptions.showFromDate,

                editor: {
                    type: "bool"
                }
            });

            formBuilder.setupDone();

            formBuilder.showAsDialog({
                title: "Edit Property Values To Include Set",

                desiredWidth: 800,
                desiredHeight: 600,

                showSaveCancel: true,
                saveButtonText: "OK",

                saveCallback: () => {
                    let newOptions = this._getSetOptions();

                    this._saveCallback(newOptions);

                    return true;
                }
            });
        }

        private _getSetOptions() {
            let newPropValuesToIncludeSetOptions: PropValuesToIncludeSetOptions = {};

            newPropValuesToIncludeSetOptions.includeList = this._formBuilder.getValueByName("includeList");

            if (this._formBuilder.getValueByName("showFromDate")) {
                newPropValuesToIncludeSetOptions.showFromDate = true;
            }

            if (!_.isEmpty(newPropValuesToIncludeSetOptions.includeList)) {
                return newPropValuesToIncludeSetOptions;
            }
            else {
                return null;
            }
        }
    }


}